import { render, staticRenderFns } from "./ManageOpening.vue?vue&type=template&id=8f87df9e&scoped=true"
import script from "./ManageOpening.vue?vue&type=script&lang=js"
export * from "./ManageOpening.vue?vue&type=script&lang=js"
import style0 from "./ManageOpening.vue?vue&type=style&index=0&id=8f87df9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f87df9e",
  null
  
)

export default component.exports